import { Project, DataFilter } from "interfaces";

import * as flowConfig from "./config";

export interface ProjectMetaData {
  [flowConfig.Y_FILTERS_KEY]: DataFilter.Filter[];
  [flowConfig.Y_TAG_ONES]: string;
  [flowConfig.Y_TAG_ZEROS]: string;
  [flowConfig.TREATMENT_FILTERS_KEY]: DataFilter.Filter[];
  [flowConfig.TREATMENT_TAG]: string;
  [flowConfig.CONTROL_TAG]: string;
}

export interface ImpactAnalysisBinaryProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.INPUT_DATA]: string;
  };
  meta_data: ProjectMetaData;
}

export const projectIsImpactAnalysisBinary = (
  project: Project
): project is ImpactAnalysisBinaryProject =>
  project.flow === flowConfig.FLOW_NAME;
